import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import FloorList, {DIRECTION} from '../../components/FloorList/FloorList'
import MediaQuery from 'react-responsive'
import FloorPlan from '../../containers/FloorPlan/FloorPlan'
import TabButtons from '../../components/TabButtons/TabButtons'
import MainHeader from '../../components/Header/MainHeader'
import Detail from '../../containers/Detail/Detail'
import {
  fetchBuildingAndFloors,
  fetchBuildingFloors,
  fetchBuildingDefaultFloors,
  fetchAdaFloors
} from '../../utils/buildings'
import {useUIDispatch, useUIState} from '../../context/UIContext'
import {
  setDrawingHighlights,
  setDrawingShowMarker,
  useDrawingDispatch
} from '../../context/DrawingContext'
import {useKioskTimer} from '../../hooks/kiosk-timer'
import {useViewFetch} from '../../utils/fetch'
import {DASHBOARD} from '../../constants/const'
import {isServiceCatalog} from '../../utils/routing'
import {getAvailableActions, useConfigState} from '../../context/ConfigContext'
import {fetchRoomsByDepartment} from '../../api/room'
import {resetHighlights} from '../../utils/highlight'

const KioskContainer = ({parentPage}) => {
  const uiState = useUIState()
  const uiDispatch = useUIDispatch()
  const drawingDispatch = useDrawingDispatch()
  const {detail, homeFloor, activeFloor, kioskId, isKiosk} = uiState
  let {show: showSearch, type: detailType, options: detailOptions} = detail
  const [showDetail, setShowDetail] = useState(true)
  const [roomToHighlight, setRoomToHighlight] = useState('')
  const [showDepartmentList, setShowDepartmentList] = useState(true)


  // isCatalogView is true when the Service Catalog is the primary app view.
  const isCatalogView = isServiceCatalog()

  const configState = useConfigState()
  const availableActions = getAvailableActions(configState)

  let {blId} = activeFloor
  if (!blId) {
	  blId = detail.options["blId"]
  }
  
  if (blId && !detail.options["blId"]){
	  showSearch = true
	  detail["type"] = "bl"
	  detail["show"] = true
	  detail.options["blId"] = blId
	  detail.options["flId"] = activeFloor.flId
  }

  const {data} = useViewFetch({
    api: fetchBuildingAndFloors,
    parameters: {blId},
    onChangeOf: [activeFloor],
    initialState: {floors: [], building: {}}
  })

  const {building, floors} = data

  useEffect(
    () => {
      resetHighlights({drawingDispatch})
      setRoomToHighlight(false)
    },
    [activeFloor, drawingDispatch]
  )
  useEffect(
    () => {
      if (roomToHighlight) {
        const highlights = {}
        highlights[roomToHighlight] = {
          stroke: '#3395fE',
          fill: 'rgba(51, 149, 254, 0.38)',
          strokeWidth: '0.35%'
        }
        setDrawingHighlights({
          dispatch: drawingDispatch,
          assetType: 'rm',
          show: true,
          highlights
        })
      }
    },
    [drawingDispatch, roomToHighlight]
  )

  useEffect(
    () => {
      if (showSearch) {
        // Clear all highlights
        resetHighlights({drawingDispatch})

        if (detailType === 'eq') {
          const {blId, flId, rmId, url} = detailOptions
          setDrawingShowMarker({dispatch: drawingDispatch, show: false})
          setShowDepartmentList(true)
          setShowDetail(true)
          uiDispatch({type: 'setActiveFloor', payload: {blId, flId}})
          const elementId = `${blId};${flId};${rmId}`
          setDrawingShowMarker({
            dispatch: drawingDispatch,
            show: true,
            elementId,
            url
          })
        }

        if (detailType === 'bl') {
          const {blId, flId, rmId, url} = detail.options
          setDrawingShowMarker({dispatch: drawingDispatch, show: false})
          

          let defaultIndex = -1
          fetchAdaFloors({blId}).then(defaults => {
        	  defaultIndex = defaults.findIndex(item => item == "Yes")
          })
          fetchBuildingFloors({blId}).then(floors => {
            setShowDetail(true)
            setShowDepartmentList(true)
			if (detail.options.flId && detail.options.flId !== "") {
				uiDispatch({
	              type: 'setActiveFloor',
	                payload: {blId, flId}
	            })
			}
        //    if (floors && floors.length) {             
            else if (floors && floors.length) {             
              if (defaultIndex === -1){
	              uiDispatch({
	                type: 'setActiveFloor',
	                payload: {blId, flId: floors[0]}
	              })
              }
              
              else{
	              uiDispatch({
		            type: 'setActiveFloor',
		            payload: {blId, flId: floors[defaultIndex]}
		          })	  
              }
            }
			
	          /*fetchEquipmentFl({blId, flId: floors[1]}).then(eqList => {
	              let i
	    	      for (i = 0; i < eqList.length; i++) {
	    		      if (eqList[i].docGraphic) {
	    		    	  let url = eqList[i].url
	    	              let elementId = `${blId};` + eqList[i].flId + `;` + eqList[i].rmId
	    	              setDrawingShowMarker({
	    	                 dispatch: drawingDispatch,
	    	                 show: true,
	    	                 elementId,
	    	                 url
	    	              })
	    		      	} 
	    	      }  
	          })*/
          })
        }

        if (detailType === 'em') {
          const {blId, flId, rmId, url} = detailOptions
          setDrawingShowMarker({dispatch: drawingDispatch, show: false})
          uiDispatch({type: 'setActiveFloor', payload: {blId, flId}})
          setShowDepartmentList(false)
          setShowDetail(true)

          const elementId = `${blId};${flId};${rmId}`
          setDrawingShowMarker({
            dispatch: drawingDispatch,
            show: true,
            elementId,
            url
          })
        }

        if (detailType === 'dp') {
          const {blId, flId, deptKey} = detailOptions
          const {dvId, dpId} = deptKey
          const departmentCode = dvId + '|' + dpId
          uiDispatch({type: 'setActiveFloor', payload: {blId, flId}})
          setShowDepartmentList(false)
          setShowDetail(false)
          fetchRoomsByDepartment({blId, flId}).then(departmentsByFloor => {
            const {rooms} = departmentsByFloor[departmentCode]
            let highlights = {}
            rooms.forEach(room => {
              highlights[room] = {
                stroke: '#2dcab5',
                fill: '#2dcab5',
                strokeWidth: '0.3%'
              }
            })
            setDrawingHighlights({
              dispatch: drawingDispatch,
              assetType: 'rm',
              show: true,
              highlights
            })
          })
        }

        if (detailType === 'rm') {
          const {blId, flId, rmId} = detailOptions
          uiDispatch({type: 'setActiveFloor', payload: {blId, flId}})
          setShowDepartmentList(false)
          setShowDetail(true)
          const roomToHighlight = `${blId};${flId};${rmId}`
          setRoomToHighlight(roomToHighlight)
        }
      } else {
        setShowDepartmentList(true)
        setDrawingShowMarker({dispatch: drawingDispatch, show: false})
      }
    },
    [detailType, showSearch, detailOptions, drawingDispatch, uiDispatch]
  )

  const isHomeFloor = false
/*
  const timeOutExpired = () =>
    uiDispatch({type: 'setActiveFloor', payload: homeFloor})
*/
 // const onClickHandler = uiDispatch({type: 'setActiveFloor', payload: activeFloor})

  const onFloorChange = selectedFloor => {
    const {bl_id: buildingCode, fl_id: floorCode} = selectedFloor
    setShowDetail(true)
    setShowDepartmentList(true)

    uiDispatch({
      type: 'setActiveFloor',
      payload: {blId: buildingCode, flId: floorCode}
    })
    /*fetchEquipmentFl({blId, flId: floorCode}).then(eqList => {
    let i
    for (i = 0; i < eqList.length; i++) {
      if (eqList[i].docGraphic) {
    	  let url = eqList[i].url
          let elementId = `${blId};` + eqList[i].flId + `;` + eqList[i].rmId
              setDrawingShowMarker({
                 dispatch: drawingDispatch,
                 show: true,
                 elementId,
                 url
              })
	      	} 
      }  
    })*/
  }

  const onTabButtonClick = action => {
    // Link to the service catalog
    action = action === 'SERVICE_SEQUENCE' ? 'SERVICE_CATALOG' : action

    uiDispatch({
      type: 'setContent',
      payload: {
        content: action,
        props: {building},
        parentPage: 'KIOSK_CONTAINER'
      }
    })
  }

  const onHomeClick = () => {
    uiDispatch({
      type: 'showSearch',
      payload: {
        show: false,
        type: null,
        options: {},
        loaded: false
      }
    })

	const homeBlId = ""
	const homeFlId = ""
	uiDispatch({
	  type: 'setHomeFloor',
	  payload: {blId: homeBlId, flId: homeFlId}
	})
	
	uiDispatch({type: 'setActiveFloor', payload: {blId: homeBlId, flId: homeFlId}})
//	uiDispatch({type: 'setActiveFloor', payload: homeFloor})
//	uiDispatch({type: 'setContent', payload: {content: DASHBOARD}})
	
    if (isKiosk) {
      setShowDepartmentList(true)
      setShowDetail(false)
    } else {
      uiDispatch({type: 'setContent', payload: {content: DASHBOARD}})
    }
  }

  const onMyLocation = () => {
    if (isKiosk) {
      const {bl_id, fl_id, rm_id} = kioskId

      uiDispatch({type: 'setActiveFloor', payload: {blId: bl_id, flId: fl_id}})
      const roomToHighlight = bl_id + ';' + fl_id + ';' + rm_id
      setRoomToHighlight(roomToHighlight)
    }
  }
  let dwgHidden = "false"
  let dwgCont = ""
  let adaCont = ""
  let expCont = ""

  const onExpand = evt => {
	  if(evt.key == "Enter" || evt.key == " " || !evt.key){
		  
		 dwgCont = document.getElementById("styled-dwg-container")
		 adaCont = document.getElementById("ada-container")
		 expCont = document.getElementById("expand-cont")
		 if (dwgCont){
			 if(dwgHidden == "false"){
			   dwgCont.style.display = "none"
			   dwgHidden = "true"
			   adaCont.style.display = "block"
			   expCont.setAttribute("aria-expanded","true")
			   adaCont.setAttribute("aria-hidden","false")

			 }else{
				dwgCont.style.display = "grid"
			    dwgHidden = "false"
			    adaCont.style.display = "none"
			    expCont.setAttribute("aria-expanded","false")
			    adaCont.setAttribute("aria-hidden","true")

			 }
		 }
	  }
  }
  

  
  return (
    <Container showDetail={showDetail}>
      <StyledHeader role="banner">
        <MainHeader building={building} parentPage={parentPage} />
      </StyledHeader>
      <MainContainer role="main">
      <Content id="mainApp" >
	      <StyledDetailContainer showDetail={showDetail}>
		      <Detail
		        showDetail={showDetail}
		        detailId={detailType}
		        options={detailOptions}
		        onExpand={onExpand}

		      />
		  </StyledDetailContainer>
		  <StyledDrawingContainer id="styled-dwg-container" aria-hidden={dwgHidden}>
		    <StyledFloorList>
		          <FloorList
		            selectedFloor={activeFloor}
		            buildingCode={blId}
		            floorList={floors}
		            direction={DIRECTION.HORIZONTAL}
		            availableOnly={false}
		            showBuilding={false}
		            onSelected={onFloorChange}
                    onHomeClick={onHomeClick}
                    showHome={!isHomeFloor}
		          />
	        </StyledFloorList>
	        <StyledContent showDetail={showDetail}>
	        <FloorPlan
	          parentView="KIOSK_CONTAINER"
	          onMyLocation={onMyLocation}
	          showDepartmentList={showDepartmentList}
	        />
	        </StyledContent>
	      </StyledDrawingContainer>
	   </Content>
	   </MainContainer>
    </Container>
  )
}

export default KioskContainer

const Container = styled.div` 
  width: 100vw;
  display: grid;
  grid-template-rows: 110px 1fr;
  box-sizing: border-box;
  
  @media (max-width: 420px) {
    grid-template-rows: 150px 1fr;
  }
`

const StyledHeader = styled.header`
  grid-row: 1;
  width: 100%;
  box-sizing: border-box;
`
const MainContainer = styled.main` 
  display: block;
`
const Content = styled.div`
  grid-row: 2;
  grid-column: 1;
  display: grid;
  grid-template-columns: 320px auto;
  
  @media (max-width: 1024px) {
    grid-template-columns: 255px auto;
  }

  @media (max-width: 768px) {
  	grid-template-columns: 100vw;
  	grid-template-rows: auto auto auto;
  }
  
  @media (max-width: 420px) {
  	grid-template-rows: auto auto;
  }
`

const StyledDetailContainer = styled.div`;
grid-column: 1;
overflow-y: auto;
overflow-x: hidden;
height: calc(100vh - 110px);

@media (max-width: 768px) {
  width: 100%;
  grid-row: 2;
  overflow-y: hidden;
  height: 100%;
}

@media (max-width: 420px) {
  grid-column: 1;
  grid-row: 2;
  padding: 0;
}
`

const StyledDrawingContainer = styled.div`
  grid-column: 2;
  display: grid;
  grid-template-rows: 70px 1fr;

  
 @media (max-width: 768px) {
  grid-column: 1;
  grid-row: 1;
}

 @media (max-width: 420px) {
  grid-template-rows: 64px 1fr;
}

`
const StyledFloorList = styled.div`
	background-color: #13294b;
	box-sizing: border-box;
	width: 100%;
	grid-row: 1;
	overflow-x: auto;
	overflow-y: hidden;
`

const StyledContent = styled.div`
  box-sizing: border-box;
  grid-row: 2;

  @media (max-width: 420px) {
    grid-column: 1;
    grid-row: 2;
  }
`

